import { render, staticRenderFns } from "./dot.vue?vue&type=template&id=13856b1a&scoped=true"
import script from "./dot.vue?vue&type=script&lang=js"
export * from "./dot.vue?vue&type=script&lang=js"
import style0 from "./dot.vue?vue&type=style&index=0&id=13856b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13856b1a",
  null
  
)

export default component.exports